<template>
    <div>
        <v-row>
            <v-col cols=12 sm=6>
                <v-currency-field
                    label="Valor de compra de la vivienda *"
                    v-model="preScoring.Vivienda.valor"
                    :rules="[...ruleMin10000,...ruleMax100M]"
                    outlined
                    append-icon="mdi-currency-eur"
                    hint="Si no conoces la cantidad definitiva introduce una estimación"
                    persistent-hint
                    dense
                ></v-currency-field>
            </v-col>
            <v-col cols=12 sm=6>
                <v-currency-field
                    label="Aportación de dinero que harás a la Compra *"
                    v-model="preScoring.Titulares.total_dinero_ahorrado"
                    :rules="[...ruleMax100M]"
                    :min="0"
                    outlined
                    append-icon="mdi-currency-eur"
                    hint="Recuerda que cuánto mas aportes, tendrás mejores condiciones y más posibilidades de obtener la financiación"
                    persistent-hint
                    dense
                ></v-currency-field>
            </v-col>
            <v-col cols=12 sm=6>
                <v-select 
                    label="¿Has encontrado vivienda? *"
                    outlined
                    v-model="preScoring.Vivienda.buscando"
                    :items="propertyStatuses"
                    :rules="[...ruleRequired]"
                    item-text="text"
                    item-value="value"
                    dense
                />
            </v-col>
            <v-col cols=12 sm=6>
                <v-select 
                    label="Tipo de vivienda *"
                    outlined
                    v-model="preScoring.Vivienda.vivienda_nueva"
                    :rules="[...ruleRequiredWith0]"
                    :items="propertyNew"
                    item-text="text"
                    item-value="value"
                    dense
                />
            </v-col>
            <v-col cols=12 sm=6 v-if="preScoring.Vivienda.vivienda_nueva === 1">
                <InputCalendar 
                    :model="preScoring.Vivienda.date_keys"
                    label="Fecha entrega de llaves"
                    outlined
                    @setDate="(payload)=>{
                        SET_DATE_KEYS({date:payload});
                    }"
                    sourceFormat="AAAA/MM/DD"
                    dense
                ></InputCalendar>
            </v-col>
            <v-col cols=12 sm=6>
                <v-text-field
                    label="Dirección de la vivienda (si la tiene)"
                    outlined
                    v-model="preScoring.Vivienda.direccion"
                    dense
                ></v-text-field>
            </v-col>
            <v-col cols=12 sm=6>
                <v-autocomplete 
                    label="Comunidad autónoma *"
                    outlined
                    v-model="preScoring.Vivienda.ccaa"
                    :items="commonVars.ccaa"
                    :rules="[...ruleRequired]"
                    item-text="name"
                    item-value="code"
                    dense
                />
            </v-col>
            <v-col cols=12 sm=6>
                <v-text-field
                    label="Código postal"
                    outlined
                    v-model="preScoring.Vivienda.cp"
                    dense
                ></v-text-field>
            </v-col>
            <v-col cols="12">
                <v-alert
                        color="#856404"
                        dark
                        icon="mdi-alert"
                        border="right"
                        text
                        >
                            En la Hipoteca "Cambio de vivienda" cuanto menos hipoteca tenga tu actual vivienda, más posibilidades de financiación tendrás.
                </v-alert>
            </v-col>
        </v-row>
        <v-row> 
             
            <v-col cols=12 sm=6>
                <v-currency-field
                    label="Valor de tu vivienda actual *"
                    v-model="preScoring.Vivienda.valor_vivienda_actual"
                    :rules="[...ruleMax100M]"
                    :min="0"
                    outlined
                    append-icon="mdi-currency-eur"
                    hint="Introduce aquí e valor aproximado de mercado de tu vivienda"
                    persistent-hint
                    dense
                ></v-currency-field>
            </v-col>
            <v-col cols=12 sm=6>
                <v-select 
                    label="¿Tiene hipoteca la vivienda? *"
                    outlined
                    v-model="preScoring.Vivienda.hipoteca_vivienda_actual"
                    :items="propertyCurrentMortgage"
                    item-text="text"
                    item-value="value"
                    dense
                />
            </v-col>
            <v-col cols=12 sm=6 v-if="preScoring.Vivienda.hipoteca_vivienda_actual === 1">
                <v-currency-field
                    label="Capital pendiente de la hipoteca *"
                    outlined
                    v-model="preScoring.Vivienda.valor_hipoteca_vivienda_actual"
                    :rules="[...ruleRequired]"
                    :min="10000"
                    :max="100000000"
                    append-icon="mdi-currency-eur"
                    hint="Importe que te queda por pagar de tu hipoteca actual"
                    persistent-hint
                    dense
                ></v-currency-field>
            </v-col>
        </v-row>

        <!-- Aval -->
        <AvalistaBlock/>
        <v-row>
            <v-col cols=12 sm=12>
                <v-textarea
                    label="Comentario"
                    placeholder='Explícanos los detalles relevantes de tu operación. Cuantos más detalles nos cuentes, más conocimiento de lo que estás buscando y mejores soluciones te propondremos'
                    v-model="preScoring.Vivienda.comentario"
                    outlined
                    dense
                ></v-textarea>
            </v-col>
        </v-row>   
    </div>
</template>

<script>
    import { mapState, mapMutations } from 'vuex';
    import rulesMixin from '../../mixins/rulesMixin';
    import InputCalendar from '../../components/InputCalendar';
    import AvalistaBlock from '../AvalistaBlock.vue';

    export default {
        mixins: [rulesMixin],
        components:{
            InputCalendar,
            AvalistaBlock
        },
        methods: {
            ...mapMutations([
                'SET_ACTIVE_STEP',
                'SET_DATE_KEYS',
                'SET_VALUE'
            ]),
        },
        computed: {
            ...mapState([
                'preScoring',
                'commonVars',
                'token_id',
                'propertyStatuses',
                'propertyNew',
                'propertyCurrentMortgage'
            ]),
        }

    }
</script>
